import { reportException } from "../gtag";

const isDevelopment = process.env.NODE_ENV === "development";

// Allow override via environment variable
const enableLogging =
  process.env.REACT_APP_ENABLE_LOGGING === "true" || isDevelopment;

const SENSITIVE_KEYS = new Set([
  "password",
  "email",
  "token",
  "accessToken",
  "idToken",
  "values",
  "file",
]);

const loggedErrorDetails = (args) => {
  const labels = [];
  let errorMessage = "";
  let errorCode = "";
  const contextParts = [];

  args.forEach((arg) => {
    if (typeof arg === "string" && arg) {
      labels.push(arg);
      return;
    }
    if (arg instanceof Error) {
      errorMessage = arg.message || errorMessage;
      errorCode = arg.code || errorCode;
      return;
    }
    if (!arg || typeof arg !== "object") {
      return;
    }
    Object.entries(arg).forEach(([key, value]) => {
      if (SENSITIVE_KEYS.has(key) || value == null || value === "") {
        return;
      }
      if (
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      ) {
        contextParts.push(`${key}=${value}`);
      }
    });
  });

  let pagePath = "";
  try {
    pagePath = window.location?.pathname || "";
  } catch (e) {
    pagePath = "";
  }

  return {
    description: labels.join(" "),
    errorMessage,
    errorCode,
    context: contextParts.join(" "),
    pagePath,
  };
};

// Create a logger that only logs in development (or when explicitly enabled)
const logger = {
  log: (...args) => {
    if (enableLogging) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (enableLogging) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Only log errors in development or when explicitly enabled (not in test or production)
    if (enableLogging) {
      console.error(...args);
    }
    const details = loggedErrorDetails(args);
    if (details.description || details.errorMessage || details.errorCode) {
      reportException(details);
    }
  },
  info: (...args) => {
    if (enableLogging) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (enableLogging) {
      console.debug(...args);
    }
  },
};

export default logger;
